import { makeStyles } from '@material-ui/styles';
import { MainButton, Text } from '@bizzabo/design-system';
import { UserPreview, useEvent } from '@bizzabo/entities';
import { FC, memo } from 'react';
import { useSetAtom } from 'jotai';
import { createChannelAtom } from 'meetings/messages';
import { useEventDetailsContext } from 'contexts/RingContext';

export type OnButtonClickCallback = () => void;

type MessageButtonProps = {
    user: UserPreview;
    onButtonClick?: OnButtonClickCallback;
};

const MessageButton: FC<MessageButtonProps> = ({ user, onButtonClick }) => {
    const classes = useStyles();
    const createChannel = useSetAtom(createChannelAtom);
    const { eventUniqueName } = useEventDetailsContext();
    const { data: event } = useEvent(eventUniqueName);

    const messageAttendee = () => {
        if (!user || user?.isHidden) {
            return;
        }

        createChannel({ members: [user.userProfileId], eventId: event?.id });
        onButtonClick?.();
    };

    return (
        <MainButton
            className={classes.messageButton}
            variant="stroke"
            size="small"
            onClick={messageAttendee}
            disabled={user?.isHidden}
        >
            <Text variant="t80" className={classes.messageButtonText}>
                Message
            </Text>
        </MainButton>
    );
};

const useStyles = makeStyles(
    () => ({
        messageButton: {
            padding: '0.165em 0.75em',
            marginLeft: 'auto',
        },
        messageButtonText: {
            display: 'block',
        },
    }),
    { classNamePrefix: 'people-user-info-message-button' }
);

export default memo(MessageButton);
